const show = 'show';
const showTitle = 'Upgrade to CUE';
const showAsset = '/static/img/components/upgrade/upgrade-shows.png';
const showLearnLink = 'https://shoflo.tv/cue-show-run-down/';
const showUpgradeLink = '';
const showDesc =
  'Upgrading to CUE will allow you to create production run ' +
  'downs, cue sheets, game scripts, and more collaboratively and in real- time ' +
  'with your crew.';

const schedule = 'schedule';
const scheduleTitle = 'Upgrade to Schedules';
const scheduleAsset = '/static/img/components/upgrade/upgrade-schedules.png';
const scheduleLearnLink = 'https://shoflo.tv/schedule/';
const scheduleUpgradeLink = '';
const scheduleDesc =
  'Upgrading to Schedules will allow you to create ' +
  'production schedules, technical schedules, and more collaboratively ' +
  ' and in real-time with your crew.';

const list = 'list';
const listTitle = 'Upgrade to Lists';
const listAsset = '/static/img/components/upgrade/upgrade-lists.png';
const listLearnLink = 'https://shoflo.tv/lists/';
const listUpgradeLink = '';
const listDesc =
  'Upgrading to Lists will allow you to create contact ' +
  'lists, equipment lists, asset lists, and more collaboratively and in ' +
  'real-time with your crew.';

const docs = 'docs';
const docsTitle = 'Upgrade to Docs';
const docsAsset = '/static/img/components/upgrade/upgrade-docs.png';
const docsLearnLink = 'https://shoflo.tv/docs/';
const docsUpgradeLink = '';
const docsDesc =
  'Upgrading to Docs will allow you to upload production ' +
  'docs, files, assets, and more collaboratively and in real-time with ' +
  'your crew.';

const teleprompter = 'teleprompter';

export default {
  types: { show, schedule, list, docs, teleprompter },
  showTitle,
  showAsset,
  showLearnLink,
  showUpgradeLink,
  showDesc,
  scheduleTitle,
  scheduleAsset,
  scheduleLearnLink,
  scheduleUpgradeLink,
  scheduleDesc,
  listTitle,
  listAsset,
  listLearnLink,
  listUpgradeLink,
  listDesc,
  docsTitle,
  docsAsset,
  docsLearnLink,
  docsUpgradeLink,
  docsDesc,
};
